import { Table as ReactTable } from "@tanstack/react-table";
import { Icon, fas } from "..";

interface DataTablePaginationProps {
    table: ReactTable<any>;
    className?: string;
}

export const DataTablePagination = ({ table, className }: DataTablePaginationProps) => {
    const { setPageIndex, getCanPreviousPage, previousPage, nextPage, getState, getPageCount, getCanNextPage } = table;

    const pageCount = getPageCount();
    const page = getState().pagination.pageIndex + 1;

    const handleFirst = () => {
        if (getCanPreviousPage()) {
            setPageIndex(0);
        }
    };

    const handleNext = () => {
        if (getCanNextPage()) {
            nextPage();
        }
    };

    const handlePrevious = () => {
        if (getCanPreviousPage()) {
            previousPage();
        }
    };

    const handleLast = () => {
        if (getCanNextPage()) {
            setPageIndex(getPageCount() - 1);
        }
    };

    return (
        <div className={`d-flex justify-content-end align-items-center ${className ?? ""}`}>
            {pageCount > 1 && (
                <>
                    <Icon
                        icon={fas.faAngleDoubleLeft}
                        className={`table-page-btn ${getCanPreviousPage() ? "" : "disabled"}`}
                        onClick={handleFirst}
                    />
                    <Icon
                        icon={fas.faAngleLeft}
                        className={`table-page-btn ${getCanPreviousPage() ? "" : "disabled"}`}
                        onClick={handlePrevious}
                    />
                    <Icon
                        icon={fas.faAngleRight}
                        className={`table-page-btn ${getCanNextPage() ? "" : "disabled"}`}
                        onClick={handleNext}
                    />
                    <Icon
                        icon={fas.faAngleDoubleRight}
                        className={`table-page-btn ${getCanNextPage() ? "" : "disabled"}`}
                        onClick={handleLast}
                    />
                    <span>
                        Page {page} of {pageCount}
                    </span>
                </>
            )}
        </div>
    );
};
